var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallOutline2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5185 18.981C11.7961 18.2985 10.0248 17.0965 8.46391 15.5356C6.90301 13.9747 5.70103 12.2034 5.01847 10.481C4.34541 8.78262 4.12684 6.99266 4.76692 5.5056C5.25417 4.3736 6.36133 3.8686 7.14612 3.60701L9.20834 2.9196C9.65905 2.76936 10.1533 2.95698 10.3907 3.36847L12.2019 6.50709C12.428 6.89904 12.3628 7.39402 12.0428 7.71401L10.5853 9.17156L14.8279 13.4142L16.2421 12C16.5578 11.6843 17.0446 11.6162 17.4349 11.833L20.6168 13.6008C21.0375 13.8345 21.2321 14.3346 21.0799 14.7911L20.3925 16.8534C20.1309 17.6382 19.6259 18.7453 18.4939 19.2326C17.0068 19.8727 15.2169 19.6541 13.5185 18.981ZM14.2553 17.1217C15.708 17.6974 16.901 17.7408 17.7032 17.3955C17.9971 17.269 18.2658 16.9089 18.4951 16.2209L18.9201 14.946L17.123 13.9476L16.2421 14.8284C15.4611 15.6095 14.1948 15.6095 13.4137 14.8284L9.17105 10.5858C8.39 9.80473 8.39 8.5384 9.17105 7.75735L10.0862 6.84225L9.06641 5.07509L7.77857 5.50437C7.09058 5.73371 6.7305 6.00236 6.60397 6.29633C6.25868 7.0985 6.30211 8.29152 6.87779 9.74418C7.44397 11.1729 8.47745 12.7207 9.87812 14.1214C11.2788 15.522 12.8266 16.5555 14.2553 17.1217Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallOutline2);
export default __webpack_public_path__ + "static/media/call_outline (2).c490bf31b62a0b0d90204dbb788ff2d3.svg";
export { ForwardRef as ReactComponent };